import { TabView, TabViewInfo } from '@pulseops/common'
import React from 'react'
import { StyleSheet, View } from 'react-native'
import { APImportFile } from './APImportFile'
import { APImportedFilesHistory } from './APImportedFilesHistory'
import { APImportedFileDetailHistory } from './APImportedFileDetailHistory'
export const APApplyingPremium = () => {
  const [isActiveTabIndex, setIsActiveTabIndex] = React.useState(0)
  const getTabList = () => {
    const tabList: TabViewInfo[] = [
      { tabName: 'Import File', tabKey: 0 },
      { tabName: 'Imported Files History', tabKey: 1 },
      { tabName: 'Imported File Detail History', tabKey: 2 }
    ]
    return tabList
  }
  const getComponentByTabKey = (tabKey: number) => {
    switch (tabKey) {
      case 0:
        return <APImportFile />
      case 1:
        return <APImportedFilesHistory />
      case 2:
        return <APImportedFileDetailHistory />
      default:
        return <></>
    }
  }
  return (
    <View style={APStyles.container}>
      <TabView
        isActiveTabIndex={isActiveTabIndex}
        setIsActiveTabIndex={setIsActiveTabIndex}
        data={getTabList()}
      ></TabView>
      {getComponentByTabKey(isActiveTabIndex)}
    </View>
  )
}
const APStyles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: 16,
  },
})